// extracted by mini-css-extract-plugin
export default {"AudienceCell":"AudiencesCell_AudienceCell__iEUsJ","disablePointer":"AudiencesCell_disablePointer__hy6O5"};